<template>
  <h1 class="dashboard-title">Tổng quan</h1>

  <div class="dashboard-grid">
    <div class="dashboard-card">
      <h3>Tổng sản phẩm tháng</h3>
      <p>{{ stats.total_products }}</p>
    </div>

    <div class="dashboard-card">
      <h3>Đơn hàng tháng này</h3>
      <p>{{ stats.total_orders }}</p>
    </div>

    <div class="dashboard-card">
      <h3>Doanh thu tháng</h3>
      <p>{{ formatCurrency(stats.total_revenue) }}</p>
    </div>

    <div class="dashboard-card">
      <h3>Khách mới</h3>
      <p>{{ stats.newCustomers }}</p>
    </div>
  </div>

  <div class="chart-box">
    <h3>Doanh thu 7 ngày gần nhất</h3>
    <div class="h-64 bg-gray-100 flex items-center justify-center">
      [Biểu đồ]
    </div>
    <div class="chart-wrapper">
        
    </div>
  </div>
</template>
<script setup>
import { statisticsApi } from "@/services/api";
import { formatCurrency } from "@/utils/helpers";
import { onMounted, ref } from "vue";

const stats = ref({});
const fetchStats = async () => {
  const response = await statisticsApi.getMonthlyStatistics();
  stats.value = {
    ...stats.value,
    ...response.data.data,
  };
};

onMounted(() => {
  fetchStats();
});
</script>

<style scoped>
.dashboard-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #333;
}

/* GRID CARDS */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
}

.dashboard-card {
  background: #fff;
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: 0.3s;
  position: relative;
  overflow: hidden;
}

.dashboard-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(135deg, #f36c21, #ffd54f);
}

.dashboard-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 15px 40px rgba(243, 108, 33, 0.25);
}

.dashboard-card h3 {
  font-size: 13px;
  color: #888;
}

.dashboard-card p {
  font-size: 28px;
  font-weight: bold;
  margin-top: 8px;
  color: #222;
}

/* CHART BOX */
.chart-box {
  margin-top: 30px;
  background: #fff;
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}
</style>
